{
  "auth": {
    "language": "Language",
    "powered_by": "Powered by"
  },
  "calendar": {
    "choose_date": "Choose a date",
    "choose_month": "Choose month",
    "choose_range": "Choose a period",
    "choose_year": "Choose year",
    "clear": "Clear",
    "max_days": "at most {{count}} days",
    "next_month": "Next month",
    "next_year": "Next year",
    "next_years": "Later years",
    "pick_end": "Pick the last day",
    "pick_start": "Pick the first day",
    "previous_month": "Previous month",
    "previous_year": "Previous year",
    "previous_years": "Earlier years",
    "today": "Today"
  },
  "change": {
    "down": "Decrease",
    "flat": "No change",
    "unknown": "Not comparable",
    "up": "Increase"
  },
  "chart": {
    "download": "Download",
    "download_excel": "Excel (current filters)",
    "download_png": "Image (PNG)",
    "fullscreen": "Full screen",
    "table_view": "Table view"
  },
  "close": "Close",
  "color_picker": {
    "choose": "Choose {{color}}",
    "contrast_dark": "Dark text: {{ratio}}:1",
    "contrast_fail": "Hard to read",
    "contrast_pass": "Readable (WCAG AA)",
    "contrast_white": "White text: {{ratio}}:1",
    "hex": "Colour code",
    "invalid": "Enter as #RRGGBB, for example #1F6FD4",
    "palette": "Suggested colours",
    "swatch": "Pick a colour"
  },
  "confirm": {
    "cancel": "Cancel",
    "pending": "Working…",
    "type_name": "Type \"{{name}}\" to confirm"
  },
  "date_names": {
    "months_long": "January,February,March,April,May,June,July,August,September,October,November,December",
    "months_of_day": "January,February,March,April,May,June,July,August,September,October,November,December",
    "months_short": "Jan,Feb,Mar,Apr,May,Jun,Jul,Aug,Sep,Oct,Nov,Dec",
    "weekdays_long": "Monday,Tuesday,Wednesday,Thursday,Friday,Saturday,Sunday",
    "weekdays_short": "Mo,Tu,We,Th,Fr,Sa,Su",
    "long_date_pattern": "{{weekday}}, {{day}} {{month}} {{year}}"
  },
  "dropzone": {
    "choose": "Choose file",
    "drop_now": "Release to drop",
    "empty": "No image yet",
    "prompt": "Drop a file here or choose one"
  },
  "image_crop": {
    "cancel": "Cancel",
    "description": "Drag the image; zoom with the wheel, two fingers or the slider.",
    "load_failed": "The image could not be opened. Choose another PNG or JPG file.",
    "loading": "Opening the image…",
    "render_failed": "The image could not be prepared. Please try again.",
    "save": "Save",
    "shape": "Shape",
    "shape_circle": "Circle",
    "shape_square": "Square",
    "stage_label": "Crop area: arrows move, + and − zoom",
    "title": "Crop image",
    "zoom": "Zoom",
    "zoom_in": "Zoom in",
    "zoom_out": "Zoom out"
  },
  "image_slot": {
    "optional": "Optional",
    "remove": "Remove",
    "replace": "Replace",
    "required": "Required"
  },
  "language_name": {
    "en": "English",
    "ru": "Русский",
    "uz": "O'zbekcha"
  },
  "page": {
    "breadcrumb": "Breadcrumb"
  },
  "password": {
    "hide": "Hide password",
    "show": "Show password"
  },
  "period": {
    "apply": "Apply",
    "cancel": "Cancel",
    "choose": "Choose period",
    "compare_data_from": "{{range}} (data from {{date}})",
    "compare_label": "Compare",
    "compare_menu": "Compare with",
    "compare_no_data": "no data",
    "compare_option": {
      "none": "No comparison",
      "previous_day": "Previous day",
      "previous_days": "Previous {{count}} days",
      "previous_month": "Previous month",
      "previous_months": "Previous {{count}} months",
      "previous_week": "Previous week",
      "previous_year": "Previous year",
      "same_day_last_year": "Same day last year",
      "same_period_last_month": "Same days last month",
      "same_period_last_week": "Same days last week",
      "same_weekday": "Same weekday last week",
      "year_over_year": "Same period last year",
      "previous_days_one": "Previous day",
      "previous_months_one": "Previous month"
    },
    "date_placeholder": "dd/mm/yyyy",
    "day_count": "Days: {{count}}",
    "from": "Start",
    "input_end_before_start": "The end is before the start",
    "input_future": "Future dates cannot be chosen",
    "input_invalid": "This date does not exist",
    "next": "Next period",
    "preset_custom": "Custom period",
    "preset_last_30_days": "Last 30 days",
    "preset_last_7_days": "Last 7 days",
    "preset_last_month": "Last month",
    "preset_this_month": "This month",
    "preset_this_year": "This year",
    "preset_today": "Today",
    "preset_yesterday": "Yesterday",
    "previous": "Previous period",
    "quick_ranges": "Quick ranges",
    "to": "End"
  },
  "progress": {
    "cancel": "Cancel",
    "remaining": "Remaining: {{time}}"
  },
  "rank": {
    "down": "Down {{count}} places",
    "medal": "Medal for place {{rank}}",
    "no_previous": "Not ranked in the previous period (no data)",
    "same": "Rank unchanged",
    "up": "Up {{count}} places",
    "down_one": "Down {{count}} place",
    "up_one": "Up {{count}} place"
  },
  "select": {
    "clear": "Clear",
    "count_of_max": "{{count}} of {{max}} selected",
    "count_selected": "{{count}} selected",
    "no_matches": "No matches",
    "search": "Search",
    "toggle_group": "all"
  },
  "shell": {
    "collapse_sidebar": "Collapse menu",
    "expand_sidebar": "Expand menu",
    "main_navigation": "Main navigation",
    "more": "More",
    "powered_by": "Powered by {{platform}}",
    "skip_to_content": "Skip to content"
  },
  "shortcuts": {
    "global": "Everywhere",
    "help": "List of shortcuts",
    "search": "Search",
    "title": "Keyboard shortcuts"
  },
  "state": {
    "empty_title": "No data",
    "error_description": "A network or server problem occurred. Please try again.",
    "error_title": "Could not load the data",
    "loading": "Loading…",
    "outages": "Outages:",
    "partial": "Incomplete",
    "partial_coverage": "Data coverage: {{percent}}%",
    "retry": "Retry",
    "stale": "Server offline — data last received at {{time}}"
  },
  "table": {
    "columns": "Columns",
    "csv": "CSV",
    "filter_placeholder": "Search…",
    "more_rows": "{{count}} more rows: narrow the list with search"
  },
  "tag_input": {
    "remove": "Remove {{value}}"
  },
  "theme": {
    "dark": "Dark",
    "light": "Light",
    "system": "System",
    "toggle": "Theme"
  },
  "totp": {
    "code_label": "6-digit code from the app",
    "confirm": "Verify and turn on",
    "digit_label": "Digit {{number}}",
    "hide_key": "Hide the key",
    "manual_key": "Enter it in the app manually:",
    "qr_label": "QR code for the authenticator app",
    "show_key": "Show the key",
    "step_code": "Enter the app's 6-digit code below",
    "step_code_title": "Enter the code",
    "step_install": "Google or Microsoft Authenticator (free)",
    "step_install_title": "Install an app on your phone",
    "step_scan": "In the app tap “+” and scan the QR code",
    "step_scan_title": "Scan the QR code"
  }
}
